import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivate } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { URLs } from 'src/assets/files/help';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  returnUrl: any;
  urls = URLs;

  constructor(private router: Router, public authService: AuthenticationService,public configService: ConfigService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve) => {
      const currentUser: any = this.authService.currentUserValue;
      this.returnUrl = state.url;
      if (currentUser) {
        const privileges = currentUser.privileges?.map(x => x.toLowerCase()) as Array<string>;
        const userMgmtEnabled = this.configService.isFeatureEnabled('userMgmt');
        const hasPrivilege = privileges?.includes('view_user_management');
        if (hasPrivilege || userMgmtEnabled) {
          resolve(true);
        } else {
          this.router.navigate(['/cp/logs']);
          resolve(false);
        }
      } else {
        this.router.navigate(['login'], { queryParams: { returnUrl: state.url } });
        resolve(false);
      }
    });
  }

  public retUrl() {
    return this.returnUrl;
  }
}
